module.exports = __webpack_public_path__ + "img/loading.03ef7eed.gif";